import * as React from "react";
import { IconProps } from "./IconProps";

export const IconLink = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="16"
        height="17"
        viewBox="0 0 16 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <g id="link-01, chain">
          <path
            id="Icon (Stroke)"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.19526 1.30806C9.45561 1.04771 9.87772 1.04771 10.1381 1.30806L14.8047 5.97472C15.0651 6.23507 15.0651 6.65718 14.8047 6.91753L12.4714 9.25086C12.2111 9.51121 11.7889 9.51121 11.5286 9.25086C11.2682 8.99051 11.2682 8.5684 11.5286 8.30806L13.3905 6.44613L9.66667 2.72227L7.80474 4.5842C7.54439 4.84455 7.12228 4.84455 6.86193 4.5842C6.60158 4.32385 6.60158 3.90174 6.86193 3.64139L9.19526 1.30806ZM10.4714 5.64139C10.7318 5.90174 10.7318 6.32385 10.4714 6.5842L6.4714 10.5842C6.21106 10.8445 5.78895 10.8445 5.5286 10.5842C5.26825 10.3238 5.26825 9.90174 5.5286 9.64139L9.5286 5.64139C9.78895 5.38104 10.2111 5.38104 10.4714 5.64139ZM4.4714 6.97472C4.73175 7.23507 4.73175 7.65718 4.4714 7.91753L2.60948 9.77946L6.33333 13.5033L8.19526 11.6414C8.45561 11.381 8.87772 11.381 9.13807 11.6414C9.39842 11.9017 9.39842 12.3238 9.13807 12.5842L6.80474 14.9175C6.54439 15.1779 6.12228 15.1779 5.86193 14.9175L1.19526 10.2509C0.934913 9.99051 0.934913 9.56841 1.19526 9.30806L3.5286 6.97472C3.78895 6.71437 4.21106 6.71437 4.4714 6.97472Z"
            fill={color}
          />
        </g>
      </svg>
    );
  },
);
